'use client';

// Route-brede error boundary (roadmap 1B): vangt render- en datafouten van
// alle pagina's, rapporteert ze naar error monitoring en biedt retry.

import { useEffect } from 'react';
import Link from 'next/link';
import { Button, Container, Group, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { friendlyMessage } from '@/lib/apiError';
import { reportError } from '@/lib/telemetry';

export default function Error({ error, reset }) {
  useEffect(() => {
    reportError(error, { source: 'error-boundary' });
  }, [error]);

  return (
    <Container size="sm" py={80}>
      <Stack align="center" gap="md" role="alert">
        <IconAlertTriangle size={56} color="var(--mantine-color-red-6)" aria-hidden />
        <Title order={1} size="h2" ta="center">
          Something went wrong
        </Title>
        <Text c="dimmed" ta="center" maw={420}>
          {friendlyMessage(error)}
        </Text>
        <Group mt="sm">
          <Button onClick={reset}>Try again</Button>
          <Button component={Link} href="/" variant="light">
            Back to homepage
          </Button>
        </Group>
      </Stack>
    </Container>
  );
}
